/**
 * Focus trap mínimo para diálogos/drawers (UX-A11Y-01). Sin dependencias:
 * lista los elementos enfocables de un contenedor y cicla el foco con Tab /
 * Shift+Tab, devolviéndolo al primero cuando escapa del contenedor.
 */

const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

/** Elementos enfocables dentro del contenedor, en orden de tabulación DOM. */
export function getFocusable(container: HTMLElement): HTMLElement[] {
  return Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR));
}

/**
 * Mantiene el foco dentro del contenedor al tabular. Debe llamarse desde un
 * handler de `keydown`. Ignora todo lo que no sea Tab.
 */
export function handleTabTrap(event: KeyboardEvent, container: HTMLElement | null): void {
  if (!container || event.key !== 'Tab') {
    return;
  }
  const items = getFocusable(container);
  const first = items[0];
  const last = items[items.length - 1];
  if (!first || !last) {
    return;
  }
  const active = document.activeElement;
  if (!container.contains(active)) {
    event.preventDefault();
    first.focus();
    return;
  }
  if (event.shiftKey && active === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && active === last) {
    event.preventDefault();
    first.focus();
  }
}
